import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }

import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import {ref, onMounted, reactive, computed} from "vue";
import { useStore } from "vuex";
import SourcePosition from "./components/CollectionPosition.vue";
import Monitoring from "./components/CollectionMonitoring.vue";
import DataComponent from "./components/CollectionData.vue";
import PVComponent from "./components/CollectionPV.vue";
import UtmComponent from "./components/CollectionUtm.vue";
import CrashComponent from "./components/CollectionCrash.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const tabsValue = ref<string>('');
const user = computed(() => {
  return store.getters.currentUser;
});

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("system.collection", ["system.management"]);
  tabsValue.value = user.value['is_superuser'] && user.value['site_id'] === 1 ? '栏位监控' : '事件数据';  // 需要先为空，再设置值，会自动调用每个tab的自动载入方法
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: tabsValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tabsValue).value = $event)),
      type: "card",
      class: "demo-tabs",
      style: {"margin":"5px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "页面栏位",
          name: "页面栏位"
        }, {
          default: _withCtx(() => [
            _createVNode(SourcePosition, { tab: tabsValue.value }, null, 8, ["tab"])
          ]),
          _: 1
        }),
        (_unref(user).is_superuser && _unref(user).site_id === 1)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "栏位监控",
              name: "栏位监控"
            }, {
              default: _withCtx(() => [
                _createVNode(Monitoring, { tab: tabsValue.value }, null, 8, ["tab"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tab_pane, {
          label: "事件数据",
          name: "事件数据"
        }, {
          default: _withCtx(() => [
            _createVNode(DataComponent, { tab: tabsValue.value }, null, 8, ["tab"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "PV数据",
          name: "PV数据"
        }, {
          default: _withCtx(() => [
            _createVNode(PVComponent, { tab: tabsValue.value }, null, 8, ["tab"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "用户来源",
          name: "用户来源"
        }, {
          default: _withCtx(() => [
            _createVNode(UtmComponent, { tab: tabsValue.value }, null, 8, ["tab"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "埋点报错",
          name: "埋点报错"
        }, {
          default: _withCtx(() => [
            _createVNode(CrashComponent, { tab: tabsValue.value }, null, 8, ["tab"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})